import axiosClient from './axiosClient';
import { IApiBaseResponse } from '~/utils/interface/common';
import { IParamsGoogleSearch } from '~/utils/interface/google';

const googleApi = {
  getGoogleMapsSearch(params: IParamsGoogleSearch) {
    const url = `api/admin/google/maps`;
    return axiosClient.get<IApiBaseResponse<any>>(url, { params });
  },
  getGoogleMapsDetail(params: IParamsGoogleSearch) {
    const url = `api/admin/google/maps/detail`;
    return axiosClient.get<IApiBaseResponse<any>>(url, { params });
  },
};

export default googleApi;
